// extracted by mini-css-extract-plugin
export default {"title":"whatWedo_title__8iq3f","root":"whatWedo_root__8JHMX","text_wrapper":"whatWedo_text_wrapper__8tSFo"};